<script setup>
import useTeesheetIntegration from "@/scripts/Utilities/TeesheetIntegrationView";
import SearchableSelect from "@/components/SearchableSelectComponent.vue";

const {
  targetCourse,
  targetProvider,
  configText,
  courses,
  providers,
  loadingSetup,
  setupIntegration,
} = useTeesheetIntegration();
</script>

<template>
  <div class="container-fluid">
    <div class="row mb-4">
      <div class="col-12">
        <h1>Teesheet Integration</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title">Course and Provider Selection</h5>
          </div>
          <div class="card-body">
            <div class="mb-3">
              <label class="form-label">Select Course</label>
              <SearchableSelect
                v-model="targetCourse"
                :options="courses"
                :label="'name'"
                :trackBy="'id'"
                :placeholder="'Select the course'"
              />
            </div>
            <div>
              <label class="form-label">Select Provider</label>
              <SearchableSelect
                v-model="targetProvider"
                :options="providers"
                :label="'name'"
                :trackBy="'id'"
                :placeholder="'Select the Provider'"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title">Configuration</h5>
          </div>
          <div class="card-body d-flex flex-column">
            <div class="form-group flex-grow-1">
              <label for="configTextarea"
                >Provider Configuration JSON Example</label
              >
              <textarea
                id="configTextarea"
                v-model="configText"
                class="form-control h-100"
                :class="{
                  'text-muted': true,
                  'bg-light': !targetCourse || !targetProvider,
                }"
                style="min-height: 300px; color: #6c757d"
                :disabled="!targetCourse || !targetProvider"
              ></textarea>
            </div>
            <div class="mt-3">
              <button
                type="button"
                class="btn btn-success mt-2"
                :disabled="
                  !targetCourse || !targetProvider || configText === ''
                "
                @click="setupIntegration"
              >
                <i v-if="loadingSetup" class="fas fa-spinner fa-spin fa-lg"></i>
                Setup Selected Course and Provider
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  margin-bottom: 1rem;
}

.container-fluid {
  padding: 20px;
}

.row {
  margin-left: 0;
  margin-right: 0;
}

.col-md-6 {
  padding: 0 0.5rem;
}

/* Textarea styling */
textarea.form-control:disabled {
  color: #adb5bd !important; /* Even darker gray when disabled */
  background-color: #e9ecef;
}
</style>
